/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('nav.mobile').click(function(e) {
          // e.preventDefault();
          $('nav.mobile').fadeOut();
        })
        $('.burger').click(function(e) {
          e.preventDefault();
          $('nav.mobile').fadeIn();
        })
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // $('.slick').on('afterChange', function(event, slick, direction){
        //   $('.slick .info').fadeOut();
        //   $('.slick .slick-current .info').fadeIn();
        // });
        // $('.slick .info').hide();
        // $('.slick .slick-current .info').show();
        // JavaScript to be fired on the home page
        //
      },
      finalize: function() {
        $('.slick').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          asNavFor: '.slickdesc'
        });
        $('.slickdesc').slick({
          arrows: false,
          fade: true,
          asNavFor: '.slick',
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          focusOnSelect: true
        });
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'members': {
      init: function() {
      },
      finalize: function() {
        initSlick();
      }
    },
    'press': {
      init: function() {
        initSlick();
      }
    },
    'news': {
      init: function() {
        initSlick();
      }
    },
    'single_projects': {
      init: function() {
        singleProjects();
        // JavaScript to be fired on the about us page
      }
    },
    'projects' : {
      init: function (){
        singleProjects();
        console.log(window.location.hash);
        if(window.location.hash == '#videokultur') {
          showVideokultur();
        } else {
          showAll();
        }

        function showAll() {
          $('#all').attr("style", "display: show");
          $('#videokultur').attr("style", "display: none !important");
        }
        function showVideokultur() {
          $('#all').attr("style", "display: none !important");
          $('#videokultur').attr("style", "display: show");
        }
        $('#allButton').click(showAll);
        $('#videokulturButton').click(showVideokultur);
      },
      finalize: function() {
        // $('#upcoming').show();
      }
    },
    'events': {
      init: function() {
        console.log(window.location.hash);
        if(window.location.hash == '#past') {
          showPast();
        } else {
          showUpcoming();
        }

        function showUpcoming() {
          $('#upcoming').attr("style", "display: table !important");
          $('#past').attr("style", "display: none !important");
        }
        function showPast() {
          $('#upcoming').attr("style", "display: none !important");
          $('#past').attr("style", "display: table !important");
        }
        $('#upcomingButton').click(showUpcoming);
        $('#pastButton').click(showPast);
      },
      finalize: function() {
        // $('#upcoming').show();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
$ = jQuery;

// SINGLE MEMBERS
function initSlick() {
  console.log('initializing');
  $('.slick').slick({
    arrows: false,
    dots: true
  });
}

function fakeNav() {
  $('.nav-tabs > ul > li > a').click(function(){
    //get displaying tab content jQuery selector
    $('.tab-content').addClass('hide');
    $('.nav-tabs > ul > li').removeClass('active');
    $(this).parent().addClass('active');

    var target_tab_selector = $(this).attr('href');
    $(target_tab_selector).removeClass('hide');
  });
}

// SINGLE PROJECTS
function singleProjects() {
  $('.slick').slick({
    arrows: false,
    dots: true
  });
}
